import React from 'react';

const StatCard = ({ title, value, icon, variant = 'blue', loading = false }) => {
  // Define color themes based on the variant prop
  const themes = {
    blue: {
      bg: 'bg-blue-50',
      border: 'border-blue-100',
      text: 'text-blue-700',
      iconBg: 'bg-blue-100',
      iconColor: 'text-blue-600'
    },
    green: {
      bg: 'bg-emerald-50',
      border: 'border-emerald-100',
      text: 'text-emerald-700',
      iconBg: 'bg-emerald-100',
      iconColor: 'text-emerald-600'
    },
    orange: {
      bg: 'bg-orange-50',
      border: 'border-orange-100',
      text: 'text-orange-700',
      iconBg: 'bg-orange-100',
      iconColor: 'text-orange-600'
    },
    red: {
      bg: 'bg-rose-50',
      border: 'border-rose-100',
      text: 'text-rose-700',
      iconBg: 'bg-rose-100',
      iconColor: 'text-rose-600'
    },
    indigo: {
      bg: 'bg-indigo-50',
      border: 'border-indigo-100',
      text: 'text-indigo-700',
      iconBg: 'bg-indigo-100',
      iconColor: 'text-indigo-600'
    }
  };

  const theme = themes[variant] || themes.blue;

  if (loading) {
    return (
      <div className={`p-6 rounded-[24px] border-2 animate-pulse ${theme.bg} ${theme.border}`}>
        <div className="h-4 w-24 bg-slate-200 rounded mb-4"></div>
        <div className="h-8 w-16 bg-slate-300 rounded"></div>
      </div>
    );
  }

  return (
    <div className={`group p-6 rounded-[24px] border-2 shadow-sm transition-all duration-300 hover:shadow-md hover:-translate-y-1 ${theme.bg} ${theme.border}`}>
      <div className="flex justify-between items-start mb-4">
        <h3 className="text-[11px] font-black uppercase tracking-[0.1em] text-slate-500 opacity-80">
          {title}
        </h3>
        {icon && (
          <div className={`p-2 rounded-xl transition-colors ${theme.iconBg} ${theme.iconColor} group-hover:bg-white`}>
            {React.cloneElement(icon, { size: 18 })}
          </div>
        )}
      </div>
      
      <div className="flex flex-col">
        <span className={`text-3xl font-black tracking-tight ${theme.text}`}>
          {value}
        </span>
        <div className="mt-2 flex items-center gap-1">
          <div className={`h-1 w-8 rounded-full ${theme.iconColor} opacity-30`}></div>
        </div>
      </div>
    </div>
  );
};

export default StatCard;